export const getOwnerDocument = (el: Element | null | undefined): Document => {
  // eslint-disable-next-line @stripe-internal/embedded/no-restricted-globals
  return el?.ownerDocument ?? document;
};

export const getOwnerWindow = (
  el: (Window & typeof global) | Element | null | undefined,
): Window & typeof global => {
  if (el && 'window' in el && el.window === el) {
    return el;
  }

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const doc = getOwnerDocument(el as Element | null | undefined);
  // eslint-disable-next-line @stripe-internal/embedded/no-restricted-globals
  return doc.defaultView || window;
};
